import { render, staticRenderFns } from "./SendTokensModal.vue?vue&type=template&id=eb265e04&scoped=true&"
import script from "./SendTokensModal.vue?vue&type=script&lang=js&"
export * from "./SendTokensModal.vue?vue&type=script&lang=js&"
import style0 from "./SendTokensModal.vue?vue&type=style&index=0&id=eb265e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb265e04",
  null
  
)

export default component.exports